import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UIRouterModule } from '@uirouter/angular';

import { TranslateModule } from '@ngx-translate/core';

import { BrandingPreviewBannerComponent } from 'rev-portal/branding/BrandingPreviewBanner.Component';
import { BrandingPreviewButtonComponent } from 'rev-portal/branding/BrandingPreviewButton.Component';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { PushModule } from 'rev-shared/push/Push.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';

import { BrandingLogoComponent } from './BrandingLogo.Component';
import { ThemeStylesComponent } from './ThemeStyles.Component';

const components = [
	BrandingLogoComponent,
	BrandingPreviewBannerComponent,
	BrandingPreviewButtonComponent,
	ThemeStylesComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		ButtonsAngularModule,
		CommonModule,
		CssRulesAngularModule,
		DirectivesAngularModule,
		PushModule,
		SecurityAngularModule,
		TranslateModule,
		UIRouterModule,
		ValidationAngularModule
	]
})
export class BrandingAngularModule {}
